namespace TabAurous.Sales {
    export namespace SalesReturnAPIService {
        export const baseUrl = '~/api/Sales/SalesReturnMasterAPI';

        export declare function Create(request: Serenity.SaveRequest<SalesReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesReturnMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesReturnMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Sales/SalesReturnMasterAPI/Create",
            Update = "~/api/Sales/SalesReturnMasterAPI/Update",
            Delete = "~/api/Sales/SalesReturnMasterAPI/Delete",
            Retrieve = "~/api/Sales/SalesReturnMasterAPI/Retrieve",
            List = "~/api/Sales/SalesReturnMasterAPI/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SalesReturnAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
